module.exports = "<ng-container *ngIf=\"errorField\">\r\n\r\n    <div *ngIf=\"!parentFormControl.invalid && parentFormControl.touched\">\r\n        <small *ngFor=\"let error of errorField\" class=\"form-text text-muted\">{{ 'BACKEND.'+error | translate }}</small>\r\n    </div>\r\n\r\n    <div *ngIf=\"parentFormControl.invalid && parentFormControl.touched\">\r\n        {{ clearBackErrors() }}\r\n    </div>\r\n\r\n</ng-container>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/field-errors.component.html
// module id = ./src/app/shared/field-errors.component.html
// module chunks = main